import { getEnvironmentWebsiteUrl } from "@shared/utils/misc.ts";
import { getEnvironmentType } from "utils/misc.tsx";
import { EXTERNAL_INVITE_PATH } from "common/constants.ts";

export const getExternalInviteLink = (token?: string) => {
  return `${getEnvironmentWebsiteUrl(
    getEnvironmentType()
  )}${EXTERNAL_INVITE_PATH}/?token=${token}`;
};
